import { render, staticRenderFns } from "./corp-join.vue?vue&type=template&id=68f02da3&scoped=true&"
import script from "./corp-join.vue?vue&type=script&lang=ts&"
export * from "./corp-join.vue?vue&type=script&lang=ts&"
import style0 from "./corp-join.vue?vue&type=style&index=0&id=68f02da3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f02da3",
  null
  
)

export default component.exports